import React from 'react'
import { StarsSection, Image } from 'newComponents'
import './styles.scss'

const CaseStudiesDetailHero = ({ contents }) => {
  const {
    title: { text: titleText },
    logo
  } = contents

  const content = (
    <div className="container case-studies-hero-content">
      <div className="case-studies-hero-content-left">
        <h1 className="title">{titleText}</h1>
      </div>
      <div className="case-studies-hero-content-right">
        <div className="case-studies-hero-logo-background">
          <Image className="case-studies-hero-logo" image={logo} />
        </div>
      </div>
    </div>
  )

  return <StarsSection className="case-studies-hero section is-xlarge bg-dark ">{content}</StarsSection>
}

export default CaseStudiesDetailHero
